import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl } from '@/helpers/api';

export const useOfferingSessionRules = (offeringSessionRuleSetId) => {
  const urlStr = `${getApiUrl()}/offering-session-rule?offeringSessionRuleSetId=${offeringSessionRuleSetId}`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });
  return swr;
};
